<template>
	<div class="container-fluid">
		<div v-if="loading" class="loader">
			<Preloader />
		</div>
		<h4 class="text-danger text-center" v-if="error">
			{{ 'pageShop.toast.error' | translate }}
		</h4>
		<h4 class="text-center" v-if="!loading && !error && profiles.length === 0">
			{{ 'reportsPage.history.empty' | translate }}
		</h4>
		<template v-if="profiles.length || checkedRole.length > 0">
			<input v-model="search" class="form-control mb-2" :placeholder="'Search' | translate" />
			<div class="d-flex">
				<div v-if="roleToNumber === 6" class="col form-check">
					<input v-model="checkedRole" @click="checkboxHandler" value="master franchise" type="checkbox"
						class="form-check-input" />
					<label class="form-check-label">{{
			'Master Franchise' | translate
		}}</label>
				</div>
				<div v-if="roleToNumber >= 5" class="col form-check">
					<input v-model="checkedRole" @click="checkboxHandler" value="franchise" type="checkbox"
						class="form-check-input" />
					<label class="form-check-label">{{ 'Franchise' | translate }}</label>
				</div>
				<div v-if="roleToNumber >= 4" class="col form-check">
					<input v-model="checkedRole" @click="checkboxHandler" value="teacher" type="checkbox"
						class="form-check-input" />
					<label class="form-check-label">{{ 'Teacher' | translate }}</label>
				</div>
				<div v-if="roleToNumber >= 3" class="col form-check">
					<input v-model="checkedRole" @click="checkboxHandler" value="parent" type="checkbox"
						class="form-check-input" />
					<label class="form-check-label">{{ 'Parents' | translate }}</label>
				</div>
				<div v-if="roleToNumber >= 3" class="col form-check">
					<input v-model="checkedRole" @click="checkboxHandler" value="student" type="checkbox"
						class="form-check-input" />
					<label class="form-check-label">{{ 'Student' | translate }}</label>
				</div>
			</div>

			<div class="table-responsive">
				<table class="table">
					<tr>
						<th>ID</th>
						<th>{{ 'Person' | translate }}</th>
						<th>{{ 'Role' | translate }}</th>
						<th>{{ 'Indigo-dollars' | translate }}</th>
						<th>{{ 'Actions' | translate }}</th>
					</tr>

					<tr v-for="profile in filteredProfiles" :key="profile.id">
						<td>{{ profile.id }}</td>
						<td>
							<a> {{ profile.last_name }} {{ profile.first_name }} </a>

							<!-- <router-link
								:to="{ name: 'Dashboard Profile', params: { id: profile.id } }"
							>
								{{ profile.last_name }} {{ profile.first_name }}
							</router-link> -->

							<!-- <router-link :to="{
								name: 'Dashboard Student Main',
								query: { read_only: profile.id, from: 'Dashboard List' },
							}">{{ 'To cabinet' | translate }}</router-link> -->
						</td>

						<td>{{ profile.role }}</td>

						<td>
							<div v-if="profile.role == 'student'" @click.prevent="showModalIndigoDollars = profile.id"
								class="indigo-dollars">
								{{ profile.balance }}
							</div>
						</td>

						<td>
							<a href="#" @click.prevent="setOpenModal(profile)" class="text-success">{{ 'Restore' | translate }}</a>
							<!-- @click.prevent="restoreUser(profile.id)" -->
						</td>


					</tr>
				</table>
			</div>

			<div class="container">
				<div class="d-flex btn-group justify-content-end">
					<button @click="paginate(-1)" v-if="pageNumber > 1" class="btn btn-outline-primary">
						{{ 'Previous' | translate }}
					</button>
					<button @click="paginate(1)" v-if="profiles.length >= 20" class="btn btn-outline-primary">
						{{ 'Next' | translate }}
					</button>
				</div>
			</div>

			<ModalIndigoDollars :id="showModalIndigoDollars" :show="!!showModalIndigoDollars" :balance="balance"
				@close="showModalIndigoDollars = false" @onEndHandler="changeUserBalance" />

			<ModalRestore :show="showModalFranchRestore" :isOkDisabled="!choosedMaster"
				@close="showModalFranchRestore = false" @restoreStudent="restoreFranch" headerText="Restore the franchise ?">
				<div v-if="roleToNumber != 5" class="form-group">
					<label>{{ 'Master Franchise' | translate }}</label>
					<v-select v-model="choosedMaster" :options="masterList" :menu-props="{ maxHeight: 'none' }" />
				</div>
			</ModalRestore>

			<ModalRestore :show="showModalTeacherRestore" :isOkDisabled="!choosedFranch"
				@close="showModalTeacherRestore = false" @restoreStudent="restoreTeacher" headerText="Restore the teacher ?">
				<div v-if="roleToNumber != 4" class="form-group">
					<label>{{ 'Franchise' | translate }}</label>
					<v-select v-model="choosedFranch" :options="franchList" :menu-props="{ maxHeight: 'none' }" />
				</div>
			</ModalRestore>

			<ModalRestore :show="showModalRestore" :isOkDisabled="!choosedGroup" @close="showModalRestore = false"
				@restoreStudent="restoreUser" headerText="Restore the student ?">
				<div v-if="roleToNumber != 3 && groupList" class="form-group">
					<label>{{ 'Teacher' | translate }}</label>
					<v-select v-model="choosedTeacher" :options="teacherList" :menu-props="{ maxHeight: 'none' }"
						:filterable="false" @search="searchTeacher" />
				</div>

				<div v-if="groupList" class="form-group">
					<label>{{ 'Group' | translate }}</label>
					<v-select v-model="choosedGroup" :options="filteredGroups" :disabled="!choosedTeacher && roleToNumber != 3" />
				</div>
			</ModalRestore>
		</template>
	</div>
</template>

<script>
import Preloader from '@/components/Loader'
import ModalRestore from '../../components/Dashboard/Modal/Restore.vue'
import ModalIndigoDollars from '../Dashboard/Modal/IndigoDollars.vue'
import vSelect from 'vue-select'

export default {
	name: 'Restore',
	data: () => ({
		profiles: [],
		loading: true,
		error: false,
		search: '',
		searchTimeout: null,

		checkedRole: [],

		// {
		// 	// This roles are equivalent for user`s role
		// 	'master franchise': false,
		// 	franchise: false,
		// 	teacher: false,
		// 	parent: false,
		// 	student: false,
		// },

		pageNumber: 1,

		showModalRestore: false,
		showModalTeacherRestore: false,
		showModalFranchRestore: false,

		showModalIndigoDollars: false,

		currentStudent: null,

		// teacherSearchQuery: '',
		groupSearchQuery: '',

		searchTeacherTimeout: null,
		searchGroupTimeout: null,

		groupList: [],
		teacherList: [],
		franchList: [],
		masterList: [],

		choosedGroup: null,
		choosedTeacher: null,
		choosedFranch: null,
		choosedMaster: null,

		// myRole: this.$store.state.myProfile.role,
	}),
	components: {
		Preloader,
		ModalRestore,
		ModalIndigoDollars,
		vSelect,
	},
	watch: {
    search(newValue) {
      if (!newValue.trim()) {
        // Avoid unnecessary API calls if search is empty
        return;
      }

      const timer = 300;
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }
      this.searchTimeout = setTimeout(() => {
        this.getList();
      }, timer);
    },

		// franchList(newValue) {
		// 	if (newValue != null) {
		// 		this.choosedFranch = newValue
		// 			? newValue.find(item => item.id == this.currentStudent.parent)
		// 			: null
		// 	}
		// },

		// masterList(newValue) {
		// 	if (newValue != null) {
		// 		this.choosedMaster = newValue
		// 			? newValue.find(item => item.id == this.currentStudent.parent)
		// 			: null
		// 	}
		// },

		choosedTeacher(newValue, oldValue) {
			
			if (newValue != null) {
				if (newValue != null) {
					this.getGroupsList(newValue.id)
				}

				if (this.currentStudent?.group?.teacher?.id === newValue.id) {
					console.log('yep')
					const {group} = this.currentStudent

					this.choosedGroup = {
						id: group.id,
						label: group.name || "-",
						teacher_id: newValue.id
					}
				} else {
					this.choosedGroup = null
				}
			}
		},

		checkedRole(newValue, oldValue) {
			if (newValue.length == 0 && oldValue.length > 0) {
				this.getList()
			}
		},
	},

	methods: {
		changeUserBalance(id, amount) {
			const index = this.profiles.findIndex(i => i.id == id);

			const newProfiles = [...this.profiles]

			if (amount) {
				newProfiles[index] = {
					...newProfiles[index],
					balance: newProfiles[index].balance + amount
				}
			}

			this.profiles = newProfiles
		},

		restoreUser() {
			this.axios({
				method: 'patch',
				url: `users/user/${this.currentStudent.id}`,
				data: {
					is_active: true,
					group: this.choosedGroup?.id
						? this.choosedGroup.id
						: this.currentStudent.group,
				},
			}).then(resp => {
				this.profiles = this.profiles.filter(
					profile => profile.id !== this.currentStudent.id
				)
				this.currentStudent = null
				this.choosedGroup = null
				this.choosedTeacher = null
			})
		},

		restoreTeacher() {
			this.axios({
				method: 'patch',
				url: `users/user/${this.currentStudent.id}`,
				data: {
					is_active: true,
					parent: this.choosedFranch?.id
						? this.choosedFranch.id
						: this.currentStudent.parent,
				},
			}).then(resp => {
				this.profiles = this.profiles.filter(
					profile => profile.id !== this.currentStudent.id
				)
				this.currentStudent = null
				this.choosedGroup = null
				this.choosedTeacher = null
				this.choosedMaster = null
			})
		},

		restoreFranch() {
			this.axios({
				method: 'patch',
				url: `users/user/${this.currentStudent.id}`,
				data: {
					is_active: true,
					parent: this.choosedMaster?.id
						? this.choosedMaster.id
						: this.currentStudent.parent,
				},
			}).then(resp => {
				this.profiles = this.profiles.filter(
					profile => profile.id !== this.currentStudent.id
				)
				this.currentStudent = null
				this.choosedGroup = null
				this.choosedTeacher = null
			})
		},

		paginate(page) {
			this.pageNumber += page
			this.getList()
		},

		getList() {
			const role =
				this.checkedRole.length > 0 ? `&role=${this.checkedRole[0]}` : ''

			this.axios({
				url: `users/restore?page=${this.pageNumber}&search=${this.search}`
				//`users?is_active=false${role}&page=${this.pageNumber}&step=21&q=${this.search}`,
			})
				.then(resp => {
					this.loading = false
					this.profiles = resp.data.results
				})
				.catch(() => {
					this.loading = false
					this.error = true
				})
		},

		// searchGroup(query) {
		// 	const timer = 500

		// 	if (this.searchGroupTimeout) {
		// 		clearTimeout(this.searchGroupTimeout)
		// 	}

		// 	this.searchGroupTimeout = setTimeout(() => {
		// 		this.getGroupsList(query)
		// 	}, timer)
		// },

		getGroupsList(teacherID = null) {
			const query = teacherID ? `?parent=${teacherID}` : '?page=1&step=51'

			this.axios({
				url: `groups/${query}`,
			}).then(response => {
				const newGroupList = []

				for (const group of response.data) {
					newGroupList.push({
						id: group.id,
						label: group.name,
						teacher: group.teacher_id,
					})
				}

				this.groupList = newGroupList

				const activeGroup = newGroupList.find(
					item => item.id === this.currentStudent?.group?.id
				)

				if(!activeGroup) {
					this.choosedGroup = null
				}
			})
		},

		searchTeacher(query) {
			const timer = 300

			if (this.searchTeacherTimeout) {
				clearTimeout(this.searchTeacherTimeout)
			}

			this.searchTeacherTimeout = setTimeout(() => {
				this.getTeachersList(query)
			}, timer)
		},

		getTeachersList(query = '') {
			this.axios({
				url: `users?role=teacher&page=1&step=21&q=${query}`,
			}).then(response => {
				let unsortedTeachersList = []

				for (const teacher of response.data) {
					unsortedTeachersList.push({
						id: teacher.id,
						label: `${teacher.last_name} ${teacher.first_name}`,
					})
				}

				this.teacherList = unsortedTeachersList.sort((a, b) =>
					a.label
						.replace(/\s+/g, '')
						.toLowerCase()
						.localeCompare(b.label.replace(/\s+/g, '').toLowerCase())
				)
			})
		},

		getFranchList() {
			this.axios({
				url: `users?role=franchise`,
			}).then(response => {
				let unsortedFranchList = []

				for (const franch of response.data) {
					unsortedFranchList.push({
						id: franch.id,
						label: `${franch.last_name} ${franch.first_name}`,
					})
				}

				this.franchList = unsortedFranchList.sort((a, b) =>
					a.label
						.replace(/\s+/g, '')
						.toLowerCase()
						.localeCompare(b.label.replace(/\s+/g, '').toLowerCase())
				)
			})
		},

		getMasterFranchList() {
			this.axios({
				url: `users?role=master%20franchise`,
			}).then(response => {
				let unsortedFranchList = []

				for (const franch of response.data) {
					unsortedFranchList.push({
						id: franch.id,
						label: `${franch.last_name} ${franch.first_name}`,
					})
				}

				this.masterList = unsortedFranchList.sort((a, b) =>
					a.label
						.replace(/\s+/g, '')
						.toLowerCase()
						.localeCompare(b.label.replace(/\s+/g, '').toLowerCase())
				)
			})
		},

		setOpenModal(profile) {
			this.currentStudent = profile

			const parent = profile.parent 
				? {id: profile.parent.id, label: `${profile.parent.first_name} ${profile.parent.last_name}`} 
				: null

			if (profile.role == 'teacher') {
				this.getFranchList()

				this.choosedFranch = parent

				this.showModalTeacherRestore = true
			} else if (profile.role == 'franchise') {
				this.getMasterFranchList()

				this.choosedMaster = parent
				
				this.showModalFranchRestore = true
			} else {
				const teacher = profile.group 
				? {id: profile.group.teacher.id, label: `${profile.group.teacher.first_name} ${profile.group.teacher.last_name}`} 
				: null

				this.choosedTeacher = teacher

				this.showModalRestore = true
			}
		},

		checkboxHandler(event) {
			this.checkedRole = [event.target.value]

			this.getList()
		},
	},
	computed: {
		balance() {
			if (this.showModalIndigoDollars) {
				const index = this.profiles.findIndex(i => i.id == this.showModalIndigoDollars);

				return this.profiles[index]?.balance
			}

			return 0
		},

		roleToNumber() {
			switch (this.$store.state.myProfile.role) {
				case 'super franchise':
					return 6
				case 'master franchise':
					return 5
				case 'franchise':
					return 4
				case 'teacher':
					return 3
				case 'parent':
					return 2
				case 'student':
					return 1
			}

			return ''
		},

		isRoleChecked() {
			for (const role in this.checkedRole) {
				if (this.checkedRole[role]) {
					return true
				}
			}

			return ''
		},

		filteredProfiles() {
      if (!this.search.trim()) {
        return this.profiles; // Show all profiles when search is empty
      }

      return this.profiles
		},
		filteredGroups() {
			if (this.choosedTeacher) {
				return this.groupList.filter(
					item => item.teacher == this.choosedTeacher.id
				)
			}

			return this.groupList
		},
	},
	created() {
		this.getList()
		this.getGroupsList()
		this.getTeachersList()
	},
}
</script>

<style scoped>
.indigo-dollars {
	cursor: pointer;
}

.disabled-link {
	color: black;
}

.loader {
	display: flex;
	align-items: center;
	justify-content: center;
}
</style>
